import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { createContentFolderRequested } from 'features/content-library/actions';

export function* createLibraryFolderSaga(action: ReturnType<typeof createContentFolderRequested>) {
  yield call(SignalingSocket.send, { event: 'createLibraryFolder', data: action.payload });
}
